module.exports = __webpack_public_path__ + "static/media/assembly_A2.fd0cd4a8.png";